import type { LstExecucao, LstStatus, LstTemplate } from '../types';

const SHIFT_END_HOUR = 18;

function scheduledClock(time: string | null | undefined): { hour: number; minute: number } | null {
  if (!time) return null;
  const parts = time.trim().split(':');
  if (parts.length < 2) return null;
  const hour = parseInt(parts[0], 10);
  const minute = parseInt(parts[1], 10);
  if (Number.isNaN(hour) || Number.isNaN(minute)) return null;
  if (hour < 0 || hour > 23 || minute < 0 || minute > 59) return null;
  return { hour, minute };
}

export function todayIsoFrom(now: Date = new Date()): string {
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
}

/**
 * O horário da rotina ainda não chegou.
 * Dia futuro permanece aberto. Dia passado permanece fechado.
 * No dia de hoje, o prazo é o horário previsto; sem horário, o fim do turno (18:00).
 */
export function isLstSlotStillOpen(
  scheduledTime: string | null | undefined,
  referenceDate: string,
  todayIso: string,
  now: Date = new Date(),
): boolean {
  if (referenceDate > todayIso) return true;
  if (referenceDate < todayIso) return false;

  const scheduled = scheduledClock(scheduledTime);
  const deadline = new Date(now);
  if (scheduled) {
    deadline.setHours(scheduled.hour, scheduled.minute, 0, 0);
  } else {
    deadline.setHours(SHIFT_END_HOUR, 0, 0, 0);
  }
  return now.getTime() <= deadline.getTime();
}

/**
 * [X] passivo: rotina vencida sem registro do líder.
 * Se já existe execução persistida, respeita o status salvo.
 */
export function resolveEffectiveLstStatus(
  template: LstTemplate,
  execucao: LstExecucao | null,
  referenceDate: string,
  now: Date = new Date(),
): LstStatus | 'pendente' {
  if (execucao?.status) return execucao.status;
  const todayIso = todayIsoFrom(now);
  if (isLstSlotStillOpen(template.scheduled_time, referenceDate, todayIso, now)) return 'pendente';
  return 'nao_realizado';
}

/** Status efetivo para exibição: pendente futuro vs X automático. */
export function resolveDisplayLstStatus(
  template: LstTemplate,
  execucao: LstExecucao | null,
  referenceDate: string,
  todayIso: string,
  now: Date = new Date(),
): LstStatus | 'pendente' {
  if (execucao?.status) return execucao.status;
  if (isLstSlotStillOpen(template.scheduled_time, referenceDate, todayIso, now)) return 'pendente';
  return 'nao_realizado';
}
